export const getYearOptions = ({ amount } = { amount: 30 }) => Array(amount).fill().map((item, index) => (
  {
    id: (index + 1) * 12,
    name: `${index + 1} jaar`,
    value: (index + 1) * 12,
  }
));


export default getYearOptions;
